<fieldset bsMigration [bs3Class]="['panel-default']" [bs4Class]="['mb-3']" formGroupName="password" class="panel" [disabled]="isSaving">
  <legend bsMigration class="panel-heading">Password</legend>
  <div bsMigration class="panel-body">
      <div [bs4Class]="['mb-2']" class="form-group" [class.has-error]="hasError">
        <label for="input-password">New Password</label>
        <input type="password" [class.is-invalid]="hasError" class="form-control" id="input-password" formControlName="cst_new_password" required placeholder="new password" [appValidateEqual]="cst_new_password_confirm" [reverse]="true">
      </div>
      <div class="form-group" [class.has-error]="hasError">
        <label for="input-password-confirm">Confirm Password</label>
        <input type="password" [class.is-invalid]="hasError" class="form-control" id="input-password-confirm" formControlName="cst_new_password_confirm" required placeholder="confirm password" [appValidateEqual]="cst_new_password">
      </div>
      <div [bs4Class]="['mt-2', 'mb-0']" class="alert alert-danger" *ngIf="hasError">
        <p [bs4Class]="['my-0']">New Password and Confirm Password are required and must match.</p>
      </div>
    </div>
</fieldset>
